export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && <div className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--gold))]">{eyebrow}</div>}
        <h1 className="text-on-bg font-heading text-3xl font-extrabold tracking-tight sm:text-4xl" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-on-bg-muted mt-1 text-base">{subtitle}</p>}
      </div>
      {children && <div className="no-print flex flex-wrap gap-2 [&>button]:ring-1 [&>button]:ring-white/30">{children}</div>}
    </div>
  );
}

export function StatCard({ label, sub, value, accent = "primary", testid }) {
  const bar = { primary: "bg-[hsl(var(--primary))]", gold: "bg-[hsl(var(--gold))]", emerald: "bg-[hsl(var(--emerald))]", coral: "bg-[hsl(var(--coral))]" }[accent];
  return (
    <div className="relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
      <span className={`absolute inset-x-0 top-0 h-1 ${bar}`} />
      <div className="text-sm font-semibold text-slate-600">{label}</div>
      {sub && <div className="text-xs text-slate-400">{sub}</div>}
      <div className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900" data-testid={`${testid}-value`}>{value}</div>
    </div>
  );
}
